import React from 'react';
import '../styles/SuccessMessage.css';

const SuccessMessage = props => (
  <div className="SuccessMessage pa3 lh-copy" {...props} />
);

export default SuccessMessage;
